/* @flow */
import CurrentUser from 'auth/CurrentUser';
import cx from 'classnames';
import FileContentPreview from 'groups/components/FileContentPreview.jsx';
import Group from 'entities/Group';
import Message from 'entities/Message';
import React from 'react';
import TranslatableText from 'chat/components/TranslatableText.jsx';
import TranslationCTA from 'chat/components/TranslationCTA.jsx';

import './styles/GroupMessageContent.scss';

class GroupMessageContent extends React.Component {
  static contextTypes = {
    message: React.PropTypes.instanceOf(Message).isRequired,
    group: React.PropTypes.instanceOf(Group),
  };

  state = {
    language: this.context.message.getISO639Locale(),
  };

  isTranslatable = () => {
    return (
      this.state.language &&
      this.context.group &&
      CurrentUser.isSignedIn() &&
      this.context.message.getISO639Locale() &&
      CurrentUser.getUser().getISO639Locale() &&
      CurrentUser.getUser().getISO639Locale() !== this.context.message.getISO639Locale() &&
      !this.context.group.isOwnedByUser(CurrentUser.getUserId())
    );
  };

  translate = () => {
    if (this.isTranslatable()) {
      this.refs.translationCTA.toggle();
    }
  };

  renderAttachments = () => {
    const { message } = this.context;

    if (message.getFiles().length === 0) {
      return null;
    }

    return (
      <div className="GroupMessageContent-attachments">
        {message.getFiles().map(file => <FileContentPreview file={file} key={file.id} />)}
      </div>
    );
  };

  renderMessage = () => {
    return (
      <div className="GroupMessageContent-body">
        <div
          onClick={this.translate}
          className={cx('GroupMessageContent-body-text',
            { 'GroupMessageContent-body-translatable': this.isTranslatable() }
          )}>
          <TranslatableText
            language={this.state.language}
            text={this.context.message.getBody()}
            onLanguageChanged={() => this.refs.translationCTA.translated()}
          />
        </div>
        {this.isTranslatable() &&
          <TranslationCTA
            ref="translationCTA"
            className="GroupMessageContent-translationCTA"
            originLanguage={this.context.message.getISO639Locale()}
            onLanguageChange={language => this.setState({ language })}
          />
        }
      </div>
    );
  };

  render() {
    return (
      <div className="GroupMessageContent">
        {this.renderMessage()}
        {this.renderAttachments()}
      </div>
    );
  }
}

export default GroupMessageContent;



// WEBPACK FOOTER //
// ./src/groups/components/GroupMessageContent.jsx